import {useContext} from 'react';
import {ServerContext} from 'coreUtils/adapters/sdk';
import {RouteInfo} from 'sfccAPI/interfaces';
import type {ICpaConnection} from 'coreUtils/cms/contentHubConnection';

export type SSRRequestData = {
	scheduledAt?: string;
	routeInfo?: RouteInfo;
	contentfulPage?: unknown;
};

export type SSRRequest = {
	data?: SSRRequestData;
	requestClasses?: string[];
	/** CMS preview API connection of the request (server only: holds the token). */
	cmsCpaConnection?: ICpaConnection;
};

/**
 * Provides access to the Express `req` object during SSR.
 * Returns `null` on the client.
 *
 * Primary use case: accessing `req.data` (middleware-prefetched data)
 * inside `useServerData` queryFns.
 */
const useSSRRequest = (): SSRRequest | null => {
	const ctx = useContext(ServerContext) as {req?: SSRRequest} | null;

	return ctx?.req ?? null;
};

export default useSSRRequest;
